import * as z from "zod/v4";
const KlaviyoCredentialsSchema_ = z.object({
    type: z.literal("klaviyo"),
    apiKey: z.string(),
});
export const KlaviyoCredentialsSchema = KlaviyoCredentialsSchema_;
const MetaCredentialsSchema_ = z.object({
    type: z.literal("meta"),
    accessToken: z.string(),
    id: z.string(),
});
export const MetaCredentialsSchema = MetaCredentialsSchema_;
const GA4CredentialsSchema_ = z.object({
    type: z.literal("ga4"),
    measurementId: z.string(),
    apiSecret: z.string(),
});
export const GA4CredentialsSchema = GA4CredentialsSchema_;
const PostscriptCredentialsSchema_ = z.object({
    type: z.literal("postscript"),
    shopToken: z.string(),
});
export const PostscriptCredentialsSchema = PostscriptCredentialsSchema_;
const SnapchatCredentialsSchema_ = z.object({
    type: z.literal("snapchat"),
    accessToken: z.string(),
    snapchatId: z.string(),
});
export const SnapchatCredentialsSchema = SnapchatCredentialsSchema_;
const TiktokCredentialsSchema_ = z.object({
    type: z.literal("tiktok"),
    accessToken: z.string(),
    tiktokId: z.string(),
});
export const TiktokCredentialsSchema = TiktokCredentialsSchema_;
const GoogleAdsCredentialsSchema_ = z.object({
    type: z.literal("googleads"),
    merchantId: z.string().optional(),
    customerId: z.string(),
    // Written by the OAuth callback, not by the merchant. Each store authorizes
    // separately, so the refresh token is per integration rather than platform
    // wide; accessToken/expiresAt are the cached exchange of it.
    refreshToken: z.string().optional(),
    accessToken: z.string().optional(),
    expiresAt: z.number().optional(),
});
export const GoogleAdsCredentialsSchema = GoogleAdsCredentialsSchema_;
const SendLaneCredentialsSchema_ = z.object({
    type: z.literal("sendlane"),
    apiKey: z.string(),
    integrationToken: z.string(),
});
export const SendLaneCredentialsSchema = SendLaneCredentialsSchema_;
const AttentiveCredentialsSchema_ = z.object({
    type: z.literal("attentive"),
    attentiveApiKey: z.string(),
});
export const AttentiveCredentialsSchema = AttentiveCredentialsSchema_;
const RedoCredentialsSchema_ = z.object({
    type: z.literal("redo"),
    redoAccessToken: z.string(),
    redoStoreId: z.string(),
    redoWidgetId: z.string().optional(),
});
export const RedoCredentialsSchema = RedoCredentialsSchema_;
export const IntegrationCredentialsSchema = z.discriminatedUnion("type", [
    KlaviyoCredentialsSchema_,
    MetaCredentialsSchema_,
    GA4CredentialsSchema_,
    PostscriptCredentialsSchema_,
    SnapchatCredentialsSchema_,
    TiktokCredentialsSchema_,
    GoogleAdsCredentialsSchema_,
    SendLaneCredentialsSchema_,
    AttentiveCredentialsSchema_,
    RedoCredentialsSchema_,
]);
//# sourceMappingURL=credentials.js.map